import moment from "moment";
import { EntreeSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/EntreeSalarieDto";
import { SortieSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/SortieSalarieDto";

export default class dataTestIDHelper {
	public static getAbsenceRequestDataTestID(typeAbsence: string | undefined, dateDebut: Date, dateFin: Date, prefix: string, suffix: string): string {
		return prefix +
			typeAbsence?.toLocaleLowerCase().replace(/ /g, "_").replace(/'/g, "_") + "-" +
			moment(dateDebut).format("DD/MM/YYYY") +
			"-" + moment(dateFin).format("DD/MM/YYYY") +
			suffix;
	}

	public static getAbsenceCellInPlanningDataTestID(salarieName: string | undefined, absenceType: string | undefined, date: Date, period: string): string {
		return salarieName?.toLocaleLowerCase().trim().replace(/ /g, "_") + "-" +
			absenceType?.toLowerCase().replace(/ /g, "_").replace(/'/g, "_") +
			"-" + moment(date).format("DD/MM/YYYY") +
			"-" + period;
	}

	public static getAddAbsenceButtonDataTestID(fullName : string) : string {
		return "absencePlanning-table-salarie-" +
			fullName.replace(" ", "_").toLowerCase() +
			"-addAbsence-button"; 
	}

	public static getEmployeeEntryRequestButton(nomSalarie: string | undefined, prefix: string, sufix: string): string {
		
		return prefix +
			nomSalarie?.replace(" ", "_").toLowerCase() +
			sufix;
	}

	public static getEntryRequestState(entree: EntreeSalarieDto): string {
		return "entryRequest-list-" +
			entree.Nom?.toLowerCase() + "_" + entree.Prenom?.toLowerCase() +
			"-state";
	}


	public static getExitRequestState(sortie: SortieSalarieDto): string {
		return "exitRequest-list-" + 
			sortie.FullName?.replace(" ", "_").toLowerCase() +
			"-state";
	}

}



// WEBPACK FOOTER //
// ./src/Helper/DataTestID/DataTestIDHelper.ts